import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './app-insights';

/**
 * Mounts under `BrowserRouter` and emits a `pageView` to
 * Application Insights every time the location changes. Lives
 * here (not in `App.tsx`) so it can be co-located with the rest
 * of the observability surface.
 */
export function TelemetryRouterListener(): null {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname, location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}
